import {AEquipment} from "./AEquipment";
import {EEquipmentType} from "../utils/EEquipmentType";
import {AElement} from "../elements/AElement";
import RemapService from "../../services/RemapService";
import {ISpecifications} from "../utils/ISpecifications";

export class Streetlight extends AEquipment {

    constructor(elements: AElement[], specifications: ISpecifications[]) {
        super(EEquipmentType.Streetlight, elements, specifications);
    }

    public static remapObjectToEquipment(object: any): Streetlight | null {
        let equipment: Streetlight | null = null;
        if(object._elements && object._specifications) {
            let elements: AElement[] = [];
            for(let i = 0; i < object._elements.length; i++) {
                let element = RemapService.remapObjectToElement(object._elements[i]);
                if(element) {
                    elements.push(element);
                }
            }
            equipment = new Streetlight(elements, object._specifications);
        }
        return equipment;
    }
}
